// copied from https://github.com/clauderic/dnd-kit/issues/1001 -> replace with some default strategy from dnd-kit when issue is fixed
import { ClientRect } from '@dnd-kit/core';
import { SortingStrategy, arrayMove } from '@dnd-kit/sortable';

const defaultScale = {
  scaleX: 1,
  scaleY: 1,
};

function getItemGap(rects: ClientRect[], index: number, activeIndex: number) {
  const currentRect: ClientRect | undefined = rects[index];
  const previousRect: ClientRect | undefined = rects[index - 1];
  const nextRect: ClientRect | undefined = rects[index + 1];

  if (!currentRect || (!previousRect && !nextRect)) {
    return 0;
  }

  if (activeIndex < index) {
    return previousRect
      ? currentRect.left - (previousRect.left + previousRect.width)
      : nextRect.left - (currentRect.left + currentRect.width);
  }

  return nextRect
    ? nextRect.left - (currentRect.left + currentRect.width)
    : currentRect.left - (previousRect.left + previousRect.width);
}

export const horizontalWrapStrategy: SortingStrategy = ({
  rects,
  activeNodeRect: fallbackActiveRect,
  activeIndex,
  overIndex,
  index,
}) => {
  const newRects = arrayMove(rects, overIndex, activeIndex);

  const oldRect = rects[index];
  const newRect = newRects[index];

  const activeNodeRect = rects[activeIndex] ?? fallbackActiveRect;

  if (!activeNodeRect) {
    return null;
  }

  const itemGap = getItemGap(rects, index, activeIndex);

  if (index === activeIndex) {
    const newIndexRect = rects[overIndex];

    if (!newIndexRect) {
      return null;
    }

    return {
      x:
        activeIndex < overIndex
          ? newIndexRect.left + newIndexRect.width - (activeNodeRect.left + activeNodeRect.width)
          : newIndexRect.left - activeNodeRect.left,
      y: newRect.top - (oldRect.top - (newRect.height - oldRect.height)),
      ...defaultScale,
    };
  }

  if (index > activeIndex && index <= overIndex) {
    return {
      x: -activeNodeRect.width - itemGap,
      y: newRect.top - (oldRect.top - (newRect.height - oldRect.height)),
      ...defaultScale,
    };
  }

  if (index < activeIndex && index >= overIndex) {
    return {
      x: activeNodeRect.width + itemGap,
      y: newRect.top - (oldRect.top - (newRect.height - oldRect.height)),
      ...defaultScale,
    };
  }

  return {
    x: 0,
    y: newRect.top - (oldRect.top - (newRect.height - oldRect.height)),
    ...defaultScale,
  };
};